// FullScreenWrapper.tsx
import { cn } from "@/lib/utils";
import React, { useState, useRef, createContext, useMemo, useEffect } from "react";

export const FullScreenContext = createContext({
    wrapperRef: null,
    toggleFullscreen: () => {},
    isFullscreen: false,
});

export const FullScreenWrapper = ({ children,className }) => {
    const wrapperRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullscreen = () => {
        const element = wrapperRef.current;

    if (!document.fullscreenElement && element) {
      element.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      console.log(wrapperRef.current,'wrapperRef.current');
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

    const contextValue = useMemo(
        () => ({
            wrapperRef,
            toggleFullscreen,
            isFullscreen,
        }),
        [isFullscreen]
    );

    return (
      <FullScreenContext.Provider value={contextValue}>
        <div
          ref={wrapperRef}
          style={{
            position: "relative",
            height: isFullscreen ? "100vh" : "auto",
            overflow: isFullscreen ? "auto" : "unset",
            padding: isFullscreen ? "2rem" : "unset", // optional styling
          }}
          className={cn('bg-background',className)}
        >
          {children}
        </div>
      </FullScreenContext.Provider>
    );
};

// export useContext hook for easier access
export const useFullScreen = () => React.useContext(FullScreenContext);
